import templateStr from 'text!edge/claim/directives/templates/claim-documents.html';
import _ from 'lodash';
import documentService from "../services/DocumentService";

export default () => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            documents: '=',
            uploadDocument: '=',
            claimState: '='
        },

        controller: ['$scope', 'httpSettings', '$window', 'ModalService', 'ViewModelService', '$stateParams', 'claim.DocumentService', '$q', '$filter', '$translate', 'claim.endpointConfig', 'InsuranceSuiteMetadata', ($scope, httpSettings, $window, ModalService, ViewModelService, $stateParams, DocumentService, $q, $filter, $translate, endpointConfig, InsuranceSuiteMetadata) => {
            $scope.alerts = [];
            $scope.documentQuery = '';
            const invoiceDocumentType = InsuranceSuiteMetadata.get('cc').types.getTypelist('DocumentType').getCode('invoice_psa').code;

            $scope.uploadEndpoint = endpointConfig.uploadEndpoint;
            $scope.documentsEndpoint = endpointConfig.documentsEndpoint;
            $scope.documentDTO = {};
            $scope.docVm = ViewModelService.create($scope.documentDTO, 'cc', 'edge.capabilities.claim.document.dto.ClaimDocumentDTO', { 'SubmittingClaim': false });
            $scope.documentTypes = $scope.docVm.documentType.aspects.availableValues.filter(function (d) {
                return d.code === 'quote_psa' || d.code === 'pictures_psa' ||
                    d.code === 'registrationcard_psa' || d.code === 'workorder_psa' || d.code === 'carmaintenanceproof_psa' || d.code === 'otherdoc_psa' ||
                    d.code === 'iban_psa' || d.code === 'diagnosis_psa' || d.code === 'videos_psa'
            })
            $scope.claimCenterDownloadURI = httpSettings.serviceBaseURLs.cc + endpointConfig.downloadEndpoint;
            $scope.documentNotFoundURL = `${$window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/ClaimDocumentError`;
            $scope.documents = $scope.documents || [];
            $scope.filteredDocuments = $scope.documents.filter(function (doc) {
                return doc.documentType != invoiceDocumentType;
            });
            $scope.recentlyAddedIDs = [];
            $scope.metadataTemplate = {
                docUID: '001',
                documentType: 'letter_received',
                securityType: 'unrestricted',
                status: 'approved',
                claimNumber: $stateParams.claimNumber
            };

            $scope.$watch('documents', () => {
                $scope.filteredDocuments = $scope.documents;
            });
            $scope.$watch('documentQuery', () => {
                $scope.applyFilter();
            });

            $scope.isRecentlyAdded = (id) => {
                return _.includes($scope.recentlyAddedIDs, id);
            };

            $scope.$on('fileuploaddone', (e, data) => {
                $scope.recentlyAddedIDs.push(data.result.result.publicID);
                //UCWAR-1390
                $scope.docVm.documentType.value = undefined;
                //UCWAR-1646
                $scope.metadataTemplate.documentType = 'letter_received';
            });

            $scope.$on('fileuploadstart', () => {
                $scope.recentlyAddedIDs = [];
            });

            $scope.applyFilter = () => {
                $scope.filteredDocuments = $filter('filter')($scope.documents, {
                    name: $scope.documentQuery
                });
            };

            $scope.closeAlert = (index) => {
                $scope.alerts.splice(index, 1);
            };

            $scope.checkError = function ($event, document) {
                const docId = document.docUID.match(/:DocId\s*=\s*"([^\"]+)"/)[1];
                const results = DocumentService.isDocumentArchived(docId);
                $event.preventDefault();
                $scope.hasError = false;
                $q.when(results).then(function (result) {
                    $scope.hasError = result;
                    if (!$scope.hasError) {
                        window.open($scope.claimCenterDownloadURI + "/" + document.publicID + "?token=" + document.sessionID + "&portalRoute=" + $scope.documentNotFoundURL, "_blank");
                    } else {
                        ModalService.showError('gateway.views.modal.Error', 'claim.directives.claim-documents.Document archived error');
                    }
                }, function (error) {
                    console.log("Error calling isDocumentArchived");
                });
            };

            $scope.removeDocument = (document) => {
                if (!document.canDelete) {
                    // only add an alert if there is not already one added
                    if (!(
                        _.find($scope.alerts, {
                            documentName: document.name
                        }))) {
                        const alertMsg = $filter('translate')('claim.directives.ClaimDocuments.Unable to delete that document', {
                            documentName: document.name
                        });
                        $scope.alerts = [];
                        $scope.alerts.push({
                            type: 'info',
                            msg: alertMsg,
                            documentName: document.name
                        });
                    }
                    return;
                }

                const title = 'claim.directives.ClaimDocuments.Remove Document';
                const msg = $translate('claim.directives.ClaimDocuments.Are you sure you want to remove', {
                    documentName: document.name
                });

                ModalService.showWarning(title, msg, null, $filter('translate')('claim.directives.ClaimDocuments.Yes'), null, $filter('translate')('claim.directives.ClaimDocuments.No'))
                    .result.then(() => {
                        $q.when(DocumentService.removeDocument($stateParams.claimNumber, document.publicID), (deleted) => {
                            if (deleted === true) {
                                for (let i = 0; i < $scope.documents.length; i++) {
                                    if (document.publicID === $scope.documents[i].publicID) {
                                        $scope.documents.splice(i, 1);
                                    }
                                }
                            } else {
                                ModalService.showWarning(
                                    'claim.directives.ClaimDocuments.Document deletion may have failed',
                                    'claim.directives.ClaimDocuments.Something may have gone wrong trying to delete your document.'
                                );
                            }
                        }, () => {
                            ModalService.showError(
                                'claim.directives.ClaimDocuments.Document deletion failed',
                                'claim.directives.ClaimDocuments.Sorry your document could not be deleted at this time'
                            );
                        });
                    });
            };

            $scope.$watch('docVm.documentType.value', () => {
                documentTypeChanged();
            });

            function documentTypeChanged() {
                if ($scope.docVm.documentType.value != undefined) {
                    $scope.metadataTemplate.documentType = $scope.docVm.documentType.value.code;
                }
            }
        }]
    };
};
